module.exports = __webpack_public_path__ + "img/live-tv-icon_red.9c99036a.svg";